import React from "react";
import { getFilesByQuery } from "../../store/fileStore/fileRequests";
import HorizontalPanel from "../../components/HorizontalPanel";
import { requestAllCountries } from "../../store/countryStore/countryRequests";
import { GeneralRequest } from "../../requests/GeneralRequest";
import FilesTable from "./FilesTable";
import EditFile from "./EditFile";
import { requestLocationByQuery } from "../../store/locationStore/locationRequests";

const FilesManagement = () => {
  return (
    <GeneralRequest requestAction={requestAllCountries}>
      <GeneralRequest requestAction={requestLocationByQuery}>
        <GeneralRequest requestAction={getFilesByQuery} requestArguments={[ {} ]}>
          <HorizontalPanel size={HorizontalPanel.SIZES.WHOLE_SPACE}>
            <FilesTable />
            <EditFile />
          </HorizontalPanel>
        </GeneralRequest>
      </GeneralRequest>
    </GeneralRequest>
  );
}

export default FilesManagement;